/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Countdown_currentMetaData = {
    readonly startDate: string;
    readonly endDate: string;
    readonly " $refType": "Countdown_currentMetaData";
};
export type Countdown_currentMetaData$data = Countdown_currentMetaData;
export type Countdown_currentMetaData$key = {
    readonly " $data"?: Countdown_currentMetaData$data;
    readonly " $fragmentRefs": FragmentRefs<"Countdown_currentMetaData">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Countdown_currentMetaData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    }
  ],
  "type": "MetaData",
  "abstractKey": null
};
(node as any).hash = '6831283f9e8ddfbb86817ff4ef2fc177';
export default node;
